import React from 'react';
import { usePermissions } from '@pankod/refine-core';
import { IResourceComponentsProps } from '@pankod/refine-core';
import {
  List,
  DateField,
  Table,
  useTable,
  DeleteButton,
  Space,
  TagField,
} from '@pankod/refine-antd';

import { LogTypes } from 'interfaces';
import { USER_ROLES } from 'constant';

const LogsList: React.FC<IResourceComponentsProps> = () => {
  const { data: permissionsData } = usePermissions();
  const { tableProps } = useTable<LogTypes>({
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    metaData: {
      fields: [
        'id',
        'action',
        'source',
        'source_name',
        'source_phone',
        'source_email',
        'performed_by',
        'createdAt',
      ],
    },
  });

  return (
    <List>
      <Table {...tableProps} rowKey='id'>
        <Table.Column
          key='performed_by'
          dataIndex='performed_by'
          title='Performed By'
        />
        <Table.Column
          key='action'
          dataIndex='action'
          title='Action Type'
          render={(action) => <TagField value={action} />}
        />
        <Table.Column
          key='source'
          dataIndex='source'
          title='Source From'
          render={(source) => <TagField value={source} />}
        />

        <Table.Column
          key='source_name'
          dataIndex='source_name'
          title='Source Name'
        />
        <Table.Column
          key='source_phone'
          dataIndex='source_phone'
          title='Source Phone'
          render={(source_phone) => <TagField value={source_phone ?? '----'} />}
        />
        <Table.Column
          key='source_email'
          dataIndex='source_email'
          title='Source Email'
          render={(source_email) => <TagField value={source_email} />}
        />

        <Table.Column
          dataIndex='createdAt'
          title='CreatedAt'
          render={(createdAt) => <DateField format='LLL' value={createdAt} />}
        />

        <Table.Column<LogTypes>
          title='Actions'
          dataIndex='actions'
          render={(_, record) => (
            <Space>
              {permissionsData?.role === USER_ROLES.SUPER_ADMIN && (
                <DeleteButton hideText size='small' recordItemId={record.id} />
              )}
            </Space>
          )}
        />
      </Table>
    </List>
  );
};

export default LogsList;
